import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle, ArrowLeft, ShoppingBag } from "lucide-react";

const PaymentCancel = () => {
  const [params] = useSearchParams();
  const orderNumber = params.get("order");

  return (
    <main className="min-h-screen bg-black text-white pt-32 pb-24">
      <div className="max-w-xl mx-auto px-6 text-center" data-testid="payment-cancel-page">
        <XCircle className="h-10 w-10 text-white/70 mx-auto" />
        <h1 className="mt-6 font-headline text-4xl md:text-5xl font-bold text-white leading-[0.95]">
          Payment cancelled.
        </h1>
        <p className="mt-4 text-white/60">
          No card was charged. Your cart is still saved — you can try again with
          a different card, or switch to Monero, Litecoin or bank transfer.
        </p>
        {orderNumber && (
          <p className="mt-4 text-xs uppercase tracking-[0.18em] text-white/40">
            Draft order · <span className="font-mono text-purple-300">{orderNumber}</span>
          </p>
        )}
        <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/cart" className="btn-primary" data-testid="retry-checkout-btn">
            <ShoppingBag className="h-4 w-4" /> Return to cart
          </Link>
          <Link to="/shop" className="btn-secondary">
            <ArrowLeft className="h-4 w-4" /> Keep shopping
          </Link>
        </div>
      </div>
    </main>
  );
};

export default PaymentCancel;
